import {
  ResponsiveContainer,
  AreaChart,
  XAxis,
  YAxis,
  Area,
  Tooltip,
  CartesianGrid,
} from "recharts";
import { format, parseISO, subDays } from "date-fns";
import "../styles/ExodusChart.module.css";
import {useState} from "react"; 
import {useEffect} from "react";
import axios from "axios"; 
import NoData from "./NoData"; 
export default function ExodusChart({user, dailyData}) {
  console.log("checking daily data from exodus"); 
  console.log(dailyData); 
  console.log('checking data');
const apiURL = import.meta.env.VITE_ENVIRONMENT === "development" ? "http://localhost:5000" : import.meta.env.VITE_API_URL;
 const data = dailyData.every((data)=>{
	return data.daily_profit == 0 && data.weekly_profit == 0; 
 }); 
  if(data){
	 return <NoData />
  }
   return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart data={dailyData}>
        <defs>
          <linearGradient id="color" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#2451B7" stopOpacity={0.4} />
            <stop offset="75%" stopColor="#2451B7" stopOpacity={0.05} />
          </linearGradient>
        </defs>

        <Area dataKey="daily_profit" stroke="#2451B7" fill="url(#color)" />
		  <Area dataKey="weekly_profit" stroke="#ad3187" fill="url(#color)" />


        <XAxis
          dataKey="date"
          axisLine={false}
          tickLine={false}
          tickFormatter={(str) => {
            const date = parseISO(str);
				return format(date, "MM");
          }}
        />
        <YAxis
          datakey="amount"
          axisLine={false}
          tickLine={false}
          tickCount={8}
          tickFormatter={(number) => `${number}`}
        />

        <Tooltip content={<CustomTooltip />} />

        <CartesianGrid opacity={0.1} vertical={false} />
      </AreaChart>
    </ResponsiveContainer>
  );
}

function CustomTooltip({ active, payload, label }) {
  if (active && payload && payload.length) {
    return (
      <div className="tooltip">
		<h4>{format(parseISO(`${label}`), "eeee, d MMM, yyyy")}</h4>
        <p>${payload[0].value} Daily Profit</p>
		  <p>${payload[1].value} Weekly Profit</p>
      </div>
    );
  }
  return null;
}
